import Loader from './Loader';

export const LoaderView = () => (
  <div>
    <Loader />
  </div>
);
